import React from 'react';
import styled from 'styled-components'

import { Box } from 'vqp-common'
import { Button } from './'

const Card = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center
`

const Title = styled.span`
    font-size: 15px;
    color: ${props => props.theme.colors.textBold}
    font-weight: 700;
    margin-bottom: 15px;
`

const Message = styled.span`
    font-size: 12px;
    color: ${props => props.theme.colors.textPrimary};
    margin-bottom: 15px;
`

const RetryButton = styled(Button)`

`

export const ErrorBox = ({message, retry}) => {
    return (
        <Card padding={"20px"}>
            <Title>Ocorreu um erro</Title>
            <Message>{message}</Message>
            {retry && (
                <RetryButton className="default" onClick={retry}>Tentar novamente</RetryButton>
            )}
        </Card>
    )
}